//#region src/printer_paper_state.ts
var PrinterPaperState = /* @__PURE__ */ function(PrinterPaperState) {
	PrinterPaperState[PrinterPaperState["Ok"] = 0] = "Ok";
	PrinterPaperState[PrinterPaperState["Low"] = 1] = "Low";
	PrinterPaperState[PrinterPaperState["Empty"] = 2] = "Empty";
	return PrinterPaperState;
}(PrinterPaperState || {});
//#endregion
export { PrinterPaperState };

//# sourceMappingURL=printer_paper_state.js.map